import { useThemeStore } from '../stores/themeStore';

export const useAppTheme = () => {
  const theme = useThemeStore((state) => state.theme);
  const setTheme = useThemeStore((state) => state.setTheme);
  const clearTheme = useThemeStore((state) => state.clearTheme);
  const isThemeLoaded = useThemeStore((state) => state.isThemeLoaded());

  return {
    theme,
    isLoaded: isThemeLoaded,
    setTheme,
    clearTheme,
  };
};
